module.exports = __webpack_public_path__ + "img/jr3.63dd07e2.png";